import CartProduct from "../components/CartProduct";
import { useCart } from "../context/CartContext";
import { useNavigate } from "react-router-dom";
// import { FiShoppingBag } from "react-icons/fi";

const Cart = () => {
  const { cartItems = [], subtotal = 0 } = useCart();
  const navigate = useNavigate();

  // ✅ Reverse to show latest added product on top
  const sortedCartItems = [...cartItems].reverse();

  return (
    <div className="max-w-6xl mx-auto px-3 md:px-4 lg:px-2 py-10 pt-28">
      {/* <h1 className="text-2xl font-semibold mb-6">
        Shopping Cart
      </h1> */}
{sortedCartItems.length === 0 ? (
  <div className="flex flex-col items-center justify-center 
                  min-h-[60vh] text-center px-4">

    {/* Image */}
    <img
      src="https://cdn-icons-png.flaticon.com/512/2038/2038854.png"
      alt="Empty Cart"
      className="w-40 md:w-52 mb-6 opacity-80"
    />

    {/* Heading */}
    <h2 className="text-2xl md:text-3xl font-semibold mb-3">
      Your Cart is Empty
    </h2>

    {/* Description */}
    <p className="text-gray-500 text-sm md:text-base max-w-md mb-6">
      Looks like you haven’t added anything yet.
      Start shopping to fill your cart with amazing products.
    </p>

    {/* Button */}
    <button
      onClick={() => navigate("/products")}
      className="bg-black text-white px-10 py-3 rounded-lg
           hover:scale-105 hover:bg-gray-800 
           transition-all duration-300 shadow-md"
    >
      Continue Shopping
    </button>
  </div>
) : (
        <div className="grid md:grid-cols-3 gap-8">
          
          {/* ================= LEFT SIDE ================= */}
          <div className="md:col-span-2 space-y-6">
            {sortedCartItems.map((item, index) => (
              <CartProduct
                key={item.id || index} 
                item={item}
              />
            ))}
          </div>

          {/* ================= RIGHT SIDE SUMMARY ================= */}
          <div className="border p-6 rounded-xl h-fit sticky top-28 shadow-sm bg-white">

            <h2 className="text-lg md:text-xl lg:text-2xl font-semibold mb-4">
              Order Summary
            </h2>

            <div className="flex justify-between mb-2 text-gray-700">
              <span>Subtotal</span>
              <span>₹{subtotal}</span>
            </div>

            <div className="flex justify-between mb-2">
              <span>Shipping</span>
              <span className="text-green-600 font-medium">
                Free
              </span>
            </div>

            <div className="border-t my-4"></div>

            <div className="flex justify-between font-semibold text-lg">
              <span>Total</span>
              <span>₹{subtotal}</span>
            </div>

            <button
              onClick={() => navigate("/checkout/address")}
              className="w-full mt-6 bg-black text-white py-3 uppercase
                         hover:bg-gray-900 transition rounded-lg"
            >
              Proceed to Checkout
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Cart;